import React from 'react'
import {Nav} from './styles'

export default function Header() {
  return (
    <Nav>
      <h3>Sven Herzog</h3>
      <a href="mailto:hi@svenherzog.com">hi@svenherzog.com</a>
    </Nav>
  )
}